module.exports = __webpack_public_path__ + "static/media/kudos-card-edit.ca9b8a63.svg";